import { render, staticRenderFns } from "./UserExtension.vue?vue&type=template&id=3b62be0f"
import script from "./UserExtension.vue?vue&type=script&lang=js"
export * from "./UserExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports